import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  root: {
    marginBottom: 24,
  },
  containerExtra: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
  smallTextButton: {
    height: 16,
    padding: 4,
    minWidth: 'unset',
    minHeight: 'unset',
    fontSize: 10,
    '& > span': {
      fontWeight: 700,
    },
  },
  icon: {
    fontSize: 14,
    marginRight: 4,
  },
}));

export default styles;
